import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {}

const BarGraphIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon width={72} height={72} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M60 36C60 35.2043 59.6839 34.4413 59.1213 33.8787C58.5587 33.3161 57.7956 33 57 33H12C11.2043 33 10.4413 33.3161 9.87868 33.8787C9.31607 34.4413 9 35.2043 9 36C9 36.7956 9.31607 37.5587 9.87868 38.1213C10.4413 38.6839 11.2043 39 12 39H57C57.7956 39 58.5587 38.6839 59.1213 38.1213C59.6839 37.5587 60 36.7956 60 36Z"
        fill="#E9004C"
      />
      <path
        d="M36 57C36 56.2043 35.6839 55.4413 35.1213 54.8787C34.5587 54.3161 33.7956 54 33 54H12C11.2043 54 10.4413 54.3161 9.87868 54.8787C9.31607 55.4413 9 56.2043 9 57C9 57.7956 9.31607 58.5587 9.87868 59.1213C10.4413 59.6839 11.2043 60 12 60H33C33.7956 60 34.5587 59.6839 35.1213 59.1213C35.6839 58.5587 36 57.7956 36 57Z"
        fill="#C45227"
      />
      <path
        d="M48 15C48 14.2044 47.6839 13.4413 47.1213 12.8787C46.5587 12.3161 45.7956 12 45 12L12 12C11.2043 12 10.4413 12.3161 9.87868 12.8787C9.31607 13.4413 9 14.2044 9 15C9 15.7956 9.31607 16.5587 9.87868 17.1213C10.4413 17.6839 11.2043 18 12 18L45 18C45.7956 18 46.5587 17.6839 47.1213 17.1213C47.6839 16.5587 48 15.7956 48 15Z"
        fill="#008563"
      />
    </SvgIcon>
  );
};

export default BarGraphIcon;
